import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=481b2bd8&scoped=true&"
import script from "./Tree.vue?vue&type=script&lang=ts&"
export * from "./Tree.vue?vue&type=script&lang=ts&"
import style0 from "./Tree.vue?vue&type=style&index=0&id=481b2bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b2bd8",
  null
  
)

export default component.exports